<template>
  <!-- 作業完了確認ダイアログ -->
  <v-dialog v-model="showDialog" width="100vw" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>車両一覧</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>

          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-sub-header>
                受付情報
              </dd-sub-header>
            </v-col>
          </v-row>

          <v-row no-gutters align-content="center">
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                    label="得意先コード/名称"
                    v-model="param.tokuisakiId"
                    ref="tokuisakiId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="得意先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    returnValueName="id"
                    :headerList="headersTorihikisakiList"
                    :itemList="filteredTorihikisakiList"
                    :readonly="true"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="取付先"
                    v-model="param.toritsukesakiNm"
                    ref="toritsukesakiNm"
                    :length="50"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="営業所"
                    v-model="param.eigyosho"
                    ref="eigyosho"
                    :length="20"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters align-content="center">
                <!--
                <v-col :cols="6" class="px-1" />
                <v-col :cols="6" class="px-1">
                  <dd-text-box
                    label="自社管理番号"
                    v-model="param.jishaDenpyoNo"
                    ref="jishaDenpyoNo"
                    :length="10"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    :readonly="true"
                  />
                </v-col>
                -->
                <v-col :cols="4" class="px-1">
                  <dd-drop-down
                    label="作業"
                    v-model="param.sagyoKbn"
                    :items="filteredSagyoKbnList"
                    :readonly="true"
                  />
                </v-col>
                <v-col :cols="8" class="px-1">
                  <dd-code-text-box
                    label="商品"
                    v-model="param.shohinId"
                    ref="shohinId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="商品検索"
                    item-value="hinmeiCd"
                    item-text="hinmeiNm"
                    returnValueName="id"
                    :headerList="headersHinmeiList"
                    :itemList="filteredShohinList"
                    :readonly="true"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="7">
              <dd-sub-header>
                <div class="d-flex">
                  <span style="display: inline-block;width:120px">作業車両</span>
                  <div style="display: inline-block;width:220px" class="mr-1 tgCheckbox">
                    <dd-checkbox
                      v-model="filterSharyoSagyoMikanryoFlg"
                      ref="filterSharyoSagyoMikanryoFlg"
                      label="作業未完了のみを表示"
                    />
                  </div>
                  <dd-custom-button
                    v-if="isShowSagyoColumn"
                    class="pa-0"
                    color="#ffffe0"
                    :whiteText="false"
                    :minWidth="160"
                    :rounded="false"
                    :tooltipDelay="0"
                    @click="onShowSagyoColumn"
                    tooltipText="追加された作業列を非表示にします。<br>入力された内容は保持されます。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  >
                    <v-icon left>
                      mdi-table-column-remove
                    </v-icon>
                    作業列を非表示
                  </dd-custom-button>
                  <dd-custom-button
                    v-else
                    class="pa-0"
                    color="#ffffe0"
                    :whiteText="false"
                    :minWidth="160"
                    :rounded="false"
                    :disabled="uketsukeSagyoList.length < 1"
                    :tooltipDelay="0"
                    @click="onShowSagyoColumn"
                    :tooltipText="uketsukeSagyoList.length < 1 ? 'オプション作業が選択されていないため使用できません' : '作業入力で指定されたオプション作業の列を追加表示します'"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  >
                    <v-icon left>
                      mdi-table-column-plus-before
                    </v-icon>
                    作業列を表示
                  </dd-custom-button>
                  <dd-custom-button
                    v-if="isShowBuzaiColumn"
                    class="pa-0"
                    color="#90ee90"
                    :whiteText="false"
                    :minWidth="160"
                    :rounded="false"
                    :tooltipDelay="0"
                    @click="onShowBuzaiColumn"
                    tooltipText="追加された部材列を非表示にします。<br>入力された内容は保持されます。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  >
                    <v-icon left>
                      mdi-table-column-remove
                    </v-icon>
                    部材列を非表示
                  </dd-custom-button>
                  <dd-custom-button
                    v-else
                    class="pa-0"
                    color="#90ee90"
                    :whiteText="false"
                    :minWidth="160"
                    :rounded="false"
                    :disabled="uketsukeBuzaiList.length < 1"
                    :tooltipDelay="0"
                    @click="onShowBuzaiColumn"
                    :tooltipText="uketsukeBuzaiList.length < 1 ? '部材が選択されていないため使用できません' : '作業入力で指定された部材の列を追加表示します'"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  >
                    <v-icon left>
                      mdi-table-column-plus-before
                    </v-icon>
                    部材列を表示
                  </dd-custom-button>
                  <dd-custom-button
                    v-if="isShowAppendixColumn"
                    class="pa-0"
                    color="#a9a9a9"
                    :whiteText="false"
                    :minWidth="170"
                    :rounded="false"
                    :tooltipDelay="0"
                    @click="onShowAppendixColumn"
                    tooltipText="付帯情報列を非表示にします。<br>入力された内容は保持されます。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  >
                    <v-icon left>
                      mdi-table-column-remove
                    </v-icon>
                    その他情報を非表示
                  </dd-custom-button>
                  <dd-custom-button
                    v-else
                    class="pa-0"
                    color="#a9a9a9"
                    :whiteText="false"
                    :minWidth="170"
                    :rounded="false"
                    :tooltipDelay="0"
                    @click="onShowAppendixColumn"
                    tooltipText="付帯情報を追加表示します"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  >
                    <v-icon left>
                      mdi-table-column-plus-before
                    </v-icon>
                    その他情報を表示
                  </dd-custom-button>
                </div>
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="4">
              <v-row no-gutters>
                <v-col :cols="8">
                  <dd-narrow-down-text-box
                    v-model="searchText"
                    :length="50"
                  />
                </v-col>
                <v-col :cols="2">
                  <dd-row-count-box
                    label="台数"
                    v-model="rowCount"
                  />
                </v-col>
                <v-col :cols="2">
                  <dd-row-count-box
                    label="絞込台数"
                    v-model="filteredRowCount"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters v-show="filteredRows.length > vitemsPerPage">
            <v-col :cols="6" class="px-1" />
            <v-col :cols="6" class="px-1">
              <v-row justify="end">
                <dd-select-items-per-page
                  ref="pagination1"
                  :itemsPerPage.sync="vitemsPerPage"
                  :currentPage.sync="vPage"
                  :items="filteredRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="filteredRows"
                height="53vh"
                class="tableTextBox"
                :search="searchText"
                no-data-text="対象データはありません"
                show-select
                v-model="selected"
                :items-per-page="vitemsPerPage"
                :page.sync="vPage"
                hide-default-header
                fixed-header
                calculate-widths
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:header="{ props }">
                  <thead class="v-data-table-header">
                    <tr>
                      <th v-for="header in props.headers" :id="header.value === 'data-table-select' ? 'tableLineHeader0' : header.thId" :class="getClass(header.value)" :key="header.index" :style="tableWidthStyle">
                        {{ header.text }}
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item, isSelected, select }">
                  <tr :class="item.delFlg === true ? 'row_delete' : ''">
                    <td class="sticky0">
                      <!-- 依頼済みのものは選択不可とする :disabled="!item.isSelectable" -->
                      <dd-checkbox
                        :disabled="item.iraisakiId !== undefined && item.iraisakiId !== null && item.iraisakiId !== ''"
                        :input-value="isSelected"
                        @change="select($event)"
                        />
                    </td>
                    <td v-for="header in headers" :class="header.tdClass" :key="header.index" :style="tableWidthStyle">
                      <!-- heder.valueにnull(文字列)が入ってる → 作業部材の紐づけコード('品名マスタID_null'or'null_その他作業部材紐づけID') -->
                      <v-icon v-if="header.value==='jissekiMikakuninFlg'&&item.jissekiMikakuninFlg&&item.checksheetCount===0" color="red accent-4">mdi-alert</v-icon>
                      <v-icon v-if="header.value==='jissekiMikakuninFlg'&&item.jissekiMikakuninFlg&&item.checksheetCount>0" color="green accent-4">mdi-new-box</v-icon>
                      <div class="tgTableIcon" v-if="header.value==='actions'&&!uketsukeShoukaiFlg">
                        <div v-if="item.delFlg===false">
                          <dd-icon-button-with-tooltip
                            message="車両の個別入力画面を表示します。"
                            icon="mdi-pencil-box-outline"
                            @click="onPopupSagyoSharyoEditOpen(item.index)"
                          />
                          <dd-icon-button-with-tooltip
                            v-if="item.trSagyoJissekiId"
                            message="作業写真を確認します。"
                            icon="mdi-camera"
                            @click="onSagyoImageDialogOpenClick(item)"
                          />
                          <dd-icon-button-with-tooltip
                            :disabled="item.index <= 1"
                            :message="item.index <= 1 ? `先頭行では使用できません` : `前行の内容を一部を除き複写します。<br>既に入力済みの内容は上書きされますので注意してください。`"
                            icon="mdi-content-duplicate"
                            @click="onSharyoCopy(item.index)"
                          />
                          <dd-icon-button-with-tooltip
                            message="車両を削除対象とします<br>保存後は元に戻せないため注意してください"
                            color="red"
                            icon="mdi-delete"
                            @click="onSharyoDelete(item)"
                          />
                        </div>
                        <div v-else>
                          <dd-icon-button-with-tooltip
                            message="車両の削除を取り消します。"
                            icon="mdi-delete-restore"
                            @click="onSharyoDelete(item)"
                          />
                        </div>
                      </div>
                      <template v-if="header.value==='keyNo'">
                        <span>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='sagyoYoteiYmdDisp'">
                        {{ item[header.value] }}
                      </template>
                      <template v-if="header.value==='jissekiSagyoYmdDisp'">
                        <div style="width:120px" v-if="!uketsukeShoukaiFlg">
                          <dd-date-box
                            label=""
                            v-model="item.jissekiSagyoYmd"
                            :readonly="item.delFlg"
                          />
                        </div>
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='iraisakiNm'">
                        <span>{{ isExpandColumn ? item['iraisakiNm'] : item['iraisakiNmAbbr'] }}</span>
                      </template>
                      <template v-if="header.value==='sagyoJisshishaNm'">
                        <span>{{ isExpandColumn ? item['sagyoJisshishaNm'] : item['sagyoJisshishaNmAbbr'] }}</span>
                      </template>
                      <template v-if="header.value==='newShabanPlateNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.newShabanPlateNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='oldShabanPlateNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.oldShabanPlateNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='newShadaiNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.newShadaiNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='sharyoBiko'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.sharyoBiko"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item['sharyoBikoAbbr'] }}</span>
                      </template>
                      <template v-if="header.value==='sharyoKeishiki'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.sharyoKeishiki"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='sharyoMaker'">
                        <dd-drop-down
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          placeholder="選択して下さい"
                          v-model="item.sharyoMaker"
                          :items="filteredSharyoMakerList"
                          :readonly="item.delFlg"
                          />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='shashu'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.shashu"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='backeyeKeishiki'">
                        <dd-drop-down
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          placeholder="選択して下さい"
                          v-model="item.backeyeKeishiki"
                          :items="filteredBackEyeFormatList"
                          :readonly="item.delFlg"
                          />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <!--
                      <template v-if="header.value==='etcKanriNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.etcKanriNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      -->
                      <template v-if="header.value==='etcKeishiki'">
                        <dd-drop-down
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          placeholder="選択して下さい"
                          v-model="item.etcKeishiki"
                          :items="filteredEtcFormatList"
                          :readonly="item.delFlg"
                          />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <!--
                      <template v-if="header.value==='newSerialNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.newSerialNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='oldSerialNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.oldSerialNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      -->
                      <template v-if="header.value==='refrigeratorMaker'">
                        <dd-drop-down
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          placeholder="選択して下さい"
                          v-model="item.refrigeratorMaker"
                          :items="filteredRefrigeratorMakerList"
                          :readonly="item.delFlg"
                          />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='doorNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.doorNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='refAnkenNo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.refAnkenNo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item[header.value] }}</span>
                      </template>
                      <template v-if="header.value==='sagyoMemo'">
                        <dd-text-box
                          v-if="!uketsukeShoukaiFlg"
                          label=""
                          v-model="item.sagyoMemo"
                          :readonly="item.delFlg"
                        />
                        <span v-else>{{ item['sagyoMemoAbbr'] }}</span>
                      </template>
                      <dd-checkbox
                        v-model="item.sagyoKanryoFlg"
                        label=""
                        v-if="header.value==='sagyoKanryoFlg'&&!uketsukeShoukaiFlg"
                        @change="item.unchinCheckTantoshaId = item.sagyoKanryoFlg ? loginUserId : null;item.unchinCheckYmd = item.sagyoKanryoFlg ? getCurrentYmdString() : null"
                        tooltipText="写真アップロードされている場合に表示されるNEWマークが消えます"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                      />
                      <dd-checkbox
                        v-model="item.uriageKakuteiFlg"
                        label=""
                        v-if="header.value==='uriageKakuteiFlg'&&!uketsukeShoukaiFlg"
                        @change="item.uriageKakuteiTantoshaId = item.uriageKakuteiFlg ? loginUserId : null;item.uriageKakuteiYmd = item.uriageKakuteiFlg ? getCurrentYmdString() : null"
                        tooltipText="チェックすると請求対象になります。<br>また、対象車両の変更はできなくなります"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                      />
                      <dd-checkbox
                        v-model="item.notYayoiRenkeiFlg"
                        label=""
                        v-if="header.value==='notYayoiRenkeiFlg'&&!uketsukeShoukaiFlg"
                        tooltipText="チェックすると弥生出力対象になりません。"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                      />
                      <dd-checkbox
                        v-model="item.matomeSeikyuFlg"
                        label=""
                        v-if="header.value==='matomeSeikyuFlg'&&!uketsukeShoukaiFlg"
                        @change="onCheckMatomeSeikyuFlg(item)"
                        tooltipText="チェックすると社長請求対象とし、弥生連携不要にします。"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                      />
                      <dd-checkbox
                        v-model="item.sagyoCancelFlg"
                        label=""
                        v-if="header.value==='sagyoCancelFlg'&&!uketsukeShoukaiFlg"
                        @change="onCheckSagyoCancelFlg(item)"
                        tooltipText="何らかの理由で作業自体がなくなった場合にチェックしてください<br>その際、キャンセル日及び理由を記載してください"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                      />
                      <dd-checkbox
                        v-model="item.notOpsUploadFlg"
                        label=""
                        v-if="header.value==='notOpsUploadFlg'&&!uketsukeShoukaiFlg"
                        tooltipText="チェックされている場合OPSアップロード出来ていないことを示します"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                      />
                      <div v-if="header.value==='uriageClosingStatus'">
                        <v-chip style="padding: 6px" small v-if="item.uriageRenkeiFlg" color="primary" outlined>済</v-chip>
                        <v-icon style="padding: 4px" small v-else-if="[undefined, null, ''].includes(item.seikyuKingakukei) || item.seikyuKingakukei <= 0">mdi-window-minimize</v-icon>
                        <v-chip style="padding: 6px" small v-else>未</v-chip>
                      </div>
                      <div v-if="header.value==='shiharaiClosingStatus'">
                        <v-chip style="padding: 6px" small v-if="item.shiharaiRenkeiFlg" color="primary" outlined>済</v-chip>
                        <v-icon style="padding: 4px" small v-else-if="[undefined, null, ''].includes(item.shiharaiKingakukei) || item.shiharaiKingakukei <= 0">mdi-window-minimize</v-icon>
                        <v-chip style="padding: 6px" small v-else>未</v-chip>
                      </div>
                      <!--
                      <template v-if="header.value==='sagyoKanryoKakuninTantoshaNm'&&item.sagyoKanryoFlg&&!uketsukeShoukaiFlg">
                        <dd-code-text-box
                          v-model="item.unchinCheckTantoshaId"
                          :length="100"
                          :style="item.delFlg ? 'border-style: none !important;' :''"
                          :valueType="Ctrls.InputTypes.Alphanumeric"
                          titleText="作業完了確認担当者"
                          return-value-name="id"
                          item-value="jininCd"
                          item-text="jininNmSei"
                          :headerList="headersJininList"
                          :itemList="filteredTantoshaList"
                          :readonly="item.delFlg"
                          tooltipText="作業完了確認を行った担当者を入力します。<br/>ログインしている担当者が自動でセットされますが変更は可能です"
                          :tooltipBottom="true"
                          :enableToolTip="helpUseFlg"
                        />
                      </template>
                      <template v-if="header.value==='sagyoKanryoKakuninYmdDisp'&&item.sagyoKanryoFlg&&!uketsukeShoukaiFlg">
                        <dd-date-box
                          label=""
                          v-model="item.unchinCheckYmd"
                          :readonly="item.delFlg"
                          tooltipText="作業完了確認の場合にチェックしてください。"
                          :tooltipBottom="true"
                          :enableToolTip="helpUseFlg"
                        />
                      </template>
                      -->
                      <!-- オプション作業 -->
                      <template v-if="header.value.includes('option')&&!uketsukeShoukaiFlg">
                        <span style="display: inline-block;width: 30px;">
                          <dd-numeric-box
                            label=""
                            v-model="item[header.value]"
                            :readonly="item.delFlg"
                            :integerDigit="10"
                            :minorDigit="0"
                            :length="10"
                            :max=9999999999
                            :min=-9999999999
                            @blur="calcSeikyuKingaku($event, item)"
                          />
                        </span>
                        <span v-if="isShowAppendixColumn" style="display: inline-block;width: 90px;padding-left: 2px;padding-right: 2px;">
                          <dd-numeric-box
                            label=""
                            v-model="item[header.value+'tanka']"
                            :readonly="item.delFlg"
                            :integerDigit="10"
                            :minorDigit="0"
                            :length="10"
                            :max=9999999999
                            :min=-9999999999
                            @blur="calcSeikyuKingaku($event, item)"
                          />
                        </span>
                      </template>
                      <!-- 部材 -->
                      <template v-if="header.value.includes('buzai')&&!uketsukeShoukaiFlg">
                        <span style="display: inline-block;width: 30px;">
                          <dd-numeric-box
                            label=""
                            v-model="item[header.value]"
                            :readonly="item.delFlg"
                            :integerDigit="10"
                            :minorDigit="0"
                            :length="10"
                            :max=9999999999
                            :min=-9999999999
                            @blur="calcSeikyuKingaku($event, item)"
                          />
                        </span>
                        <span v-if="isShowAppendixColumn" style="display: inline-block;width: 90px;padding-left: 2px;padding-right: 2px;">
                          <dd-numeric-box
                            v-if="isShowAppendixColumn"
                            label=""
                            v-model="item[header.value+'tanka']"
                            :readonly="item.delFlg"
                            :integerDigit="10"
                            :minorDigit="0"
                            :length="10"
                            :max=9999999999
                            :min=-9999999999
                            @blur="calcSeikyuKingaku($event, item)"
                          />
                        </span>
                      </template>
                      <!-- 請求金額 -->
                      <template v-if="header.value.includes('seikyuKingakuKei')&&!uketsukeShoukaiFlg">
                        <span>{{ item['seikyuKingakuKeiDisp'] }}</span>
                      </template>
                      <!-- 請求金額 -->
                      <template v-if="header.value.includes('shiharaiKingakuKei')&&!uketsukeShoukaiFlg">
                        <span>{{ item['shiharaiKingakuKeiDisp'] }}</span>
                      </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row no-gutters v-show="filteredRows.length > vitemsPerPage">
            <v-col :cols="6" class="px-1" />
            <v-col :cols="6" class="px-1">
              <v-row justify="end">
                <dd-select-items-per-page
                  ref="pagination2"
                  :itemsPerPage.sync="vitemsPerPage"
                  :currentPage.sync="vPage"
                  :items="filteredRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-dialog v-model="showImageDialog" width="50vw" persistent no-click-animation scrollable>
        <v-card>
          <v-toolbar elevation="2" color="#2F75B5" dark dense>
            <v-spacer></v-spacer>
            <v-toolbar-title>作業写真一覧</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="onImageDialogCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>

              <v-row no-gutters>
                <v-col :cols="12">
                  <dd-sub-header>
                    写真一覧
                    <dd-custom-button
                      color="green"
                      dark
                      @click="onShashinHimodukeDialogOpenClick"
                      v-if="!uketsukeShoukaiFlg"
                      tooltipText="写真情報選択画面を別画面で開きます"
                      :tooltipTop="true"
                      :enableToolTip="helpUseFlg">
                      写真紐づけ
                    </dd-custom-button>
                  </dd-sub-header>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <dd-data-table
                    calculate-widths
                    item-key="id"
                    :headers="shashinHeaders"
                    :items="filteredShashinRows"
                    class="wrapTable"
                    fixed-header
                    height="100%"
                    locale="ja-jp"
                    no-data-text="利用可能なデータはありません。"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:[`item.content`]="{ item }">
                      <div class="d-flex justify-center">
                        <dd-icon-button-with-tooltip
                          v-if="item.fileKbn==='noImg'"
                          message="ファイルをダウンロードします。"
                          icon="mdi-download-box"
                          @click="onSagyoImagePdfDownload(item)"
                        />
                        <img
                          v-if="item.fileKbn==='img'"
                          :src="item.content"
                          class="img"
                          onload="this.style.display='block';"
                          onerror="this.style.display='none';"
                          width="100%"
                          @click="onImageOpenButtonClick(item)"
                        />
                      </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <div class="d-flex justify-center">
                        <dd-icon-button-with-tooltip
                          message="アップロードされたチェックシートを削除します"
                          icon="mdi-note-remove"
                          color="red"
                          :small="true"
                          @click="onImageDeleteButtonClick(item)"
                        />
                      </div>
                    </template>
                  </dd-data-table>
                </v-col>
              </v-row>
              <a
                id="sagyoImageDownload"
                href="#"
                style="display: none"
              >
                ダウンロード
              </a>

            </v-container>
          </v-card-text>

          <v-card-actions>

            <dd-footer-button
              @click="onImageDialogCloseButtonClick"
              tooltipText="この画面を終了して前の画面へ戻ります"
              :tooltipTop="true"
              :enableToolTip="helpUseFlg">
              <v-icon>mdi-window-close</v-icon>
              閉じる
            </dd-footer-button>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-actions>
        <dd-footer-button
          @click="onCloseButtonClick"
          tooltipText="この画面を終了して前の画面へ戻ります"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
        >
          <v-icon>mdi-window-close</v-icon>
          閉じる
        </dd-footer-button>

        <dd-custom-button
          color="blue"
          :outlined="true"
          @click="onSwitchExpandColumn"
          :tooltipText="isExpandColumn ? `列の幅を縮小します` : `列の幅を拡大します`"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
        >
          <span v-if="isExpandColumn">列幅縮小</span>
          <span v-else>列幅拡大</span>
        </dd-custom-button>

        <v-spacer></v-spacer>

        <dd-custom-button
          :outlined="true"
          :minWidth="160"
          @click="onSharyoJohoInputButtonClick"
          tooltipText="車両一覧ファイルを指定して取込を行うことができます"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
          >
          <v-icon>mdi-file-upload-outline</v-icon>
          車両情報取込
        </dd-custom-button>
        <!-- 同一が指定された時の為にclickイベントでファイル情報を空にする -->
        <v-file-input
          v-model="sharyoTorikomiFile"
          ref="sharyoTorikomiFile"
          v-show="false"
          @change="onSharyoJohoFileChanged"
          @click="(e) => { e.target.value = '' }"
          accept="text/csv"
        />
        <dd-custom-button
          :outlined="true"
          :minWidth="160"
          @click="onSharyoJohoOutputButtonClick"
          tooltipText="登録されている車両の一覧データを出力します"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
          >
          <v-icon>mdi-file-download-outline</v-icon>
          車両情報出力
        </dd-custom-button>
        <a id="sharyoDownload" href="#" style="display: none" />
        <dd-custom-button
          :outlined="true"
          :minWidth="160"
          @click="onPopupSagyoSharyoListEditOpen"
          tooltipText="登録されている車両の一覧編集画面を開きます<br>※EXCELの様に編集できます。"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
          >
          <v-icon>mdi-pencil-box-multiple-outline</v-icon>
          車両一括編集
        </dd-custom-button>

        <v-spacer></v-spacer>

        <dd-custom-button
          v-if="!uketsukeShoukaiFlg"
          @click="onSagyoIraiClick"
          :disabled="isDisableSagyoIrai"
          color="green"
          :outlined="true"
          tooltipText="選択した車両の作業依頼をします"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
          >
          <v-icon>mdi-email-edit-outline</v-icon>
          選択した車両を作業依頼する
        </dd-custom-button>

        <v-spacer></v-spacer>

        <dd-footer-button
          v-if="!uketsukeShoukaiFlg"
          @click="onSaveButtonClick"
          tooltipText="入力内容を保存します"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
          >
          <v-icon>mdi-sync</v-icon>
          反映して閉じる
        </dd-footer-button>
      </v-card-actions>
    </v-card>

    <tg-popup-shashin-himoduke-dialog
      :id="id"
      :hacchuKihonId="shashinHimodukeParam.hacchuKihonId"
      :sagyoJissekiId="sagyoImageJissekiId"
      :sagyoMeisaiId="himodukeSagyoMeisaiId"
      :showDialog="showShashinHimodukeDialog"
      @close="onShashinHimodukeDialogClose"
    />

    <tg-popup-sagyo-sharyo-edit
      :showDialog="isShowPopupSagyoSharyoEdit"
      :id="sharyoId"
      :juchuKihonId="juchuKihonId"
      :juchuMeisaiId="id"
      :param="sharyoParam"
      :uketsukeShoukaiFlg="uketsukeShoukaiFlg"
      @close="onPopupSagyoSharyoEditClose"
      @edited="onSharyoEdited"
    />

    <tg-popup-sagyo-sharyo-list-edit
      :showDialog="isShowPopupSagyoSharyoListEdit"
      :sharyoList="filteredRows"
      :useRefAnkenNo="param.useRefAnkenNo"
      @close="onPopupSagyoSharyoListEditClose"
      @save="onPopupSagyoSharyoListEditSave"
    />

  </v-dialog>
</template>
<script>
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdDateBox from '@/components/DdDateBox'
import DdDataTable from '@/components/DdDataTable'
import DdDropDown from '@/components/DdDropDown'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'

import TgPopupShashinHimodukeDialog from '@/components/TgPopupShashinHimodukeDialog'
import TgPopupSagyoSharyoEdit from '@/components/TgPopupSagyoSharyoEdit'
import TgPopupSagyoSharyoListEdit from '@/components/TgPopupSagyoSharyoListEdit'

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import dolly from '@/rahmen/utils/dolly'
import formatter from '@/ddv2.library/utils/formatter'
import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

const IMAGE_EXTENTION_LIST = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'gif', 'GIF', 'bmp', 'BMP']

export default {
  name: 'TgPopupSagyoSharyoList',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdNumericBox,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    TgPopupShashinHimodukeDialog,
    TgPopupSagyoSharyoEdit,
    TgPopupSagyoSharyoListEdit
  },
  props: {
    /**
     * 受注明細ID
     */
    id: {
      type: Number,
      default: 0
    },
    /**
     * 画面表示フラグ
     */
    showDialog: {
      type: Boolean,
      default: false
    },
    /**
     * 現在受付の請求ランク
     */
    seikyuRank: {
      type: String,
      default: '01'
    },
    /**
     * 照会モード
     */
    uketsukeShoukaiFlg: {
      type: Boolean,
      default: false
    },
    /**
     * 受付情報
     */
    param: {
      type: Object
    },
    /**
     * 車両リスト
     */
    uketsukeSharyoList: {
      type: Array
    },
    /**
     * 車両基本作業リスト
     */
    uketsukeSharyoKihonList: {
      type: Array
    },
    /**
     * 車両オプション作業リスト
     */
    uketsukeSharyoOptionList: {
      type: Array
    },
    /**
     * 車両部材リスト
     */
    uketsukeSharyoBuzaiList: {
      type: Array
    },
    /**
     * 受付部材リスト
     */
    uketsukeSagyoList: {
      type: Array
    },
    /**
     * 受付部材リスト
     */
    uketsukeBuzaiList: {
      type: Array
    }
  },
  data: () => ({
    // ヘッダー定義
    headersHinmeiList: header.mstHinmeiHeaders,
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,

    // 作業依頼選択用
    selected: [],

    // 列幅変更
    isExpandColumn: false,

    // 列固定用定義
    stickyWidth: [],

    // ページネーション用
    vitemsPerPage: 0,
    vPage: 1,

    headers: [],
    rows: [],
    searchText: '',
    filterSharyoSagyoMikanryoFlg: false,

    showImageDialog: false,
    sagyoImageTargetItem: null,
    sagyoImageJissekiId: null,
    sharyoTorikomiFile: null,

    shashinHeaders: [
      { text: '写真', value: 'content', width: '150px' },
      { text: '詳細', value: 'sagyoImageText' },
      { text: '削除', value: 'actions', width: '20px' }
    ],
    shashinRows: [],

    showShashinHimodukeDialog: false,
    shashinHimodukeParam: {
      hacchuKihonId: null,
      sagyoJissekiId: null
    },
    himodukeSagyoMeisaiId: null,

    juchuKihonId: 0,
    sharyoId: 0,
    sharyoParam: {
      unchinKakuteiFlg: false,
      seikyuRank: null,
      sagyoKbn: null,
      shohinId: null,
      uketsukeSagyoList: [],
      uketsukeBuzaiList: [],
      index: null
    },
    isShowSagyoColumn: true,
    isShowBuzaiColumn: true,
    isShowAppendixColumn: false,
    isShowPopupSagyoSharyoEdit: false,
    isShowPopupSagyoSharyoListEdit: false,
    // 編集領域
    recSharyo: {}
  }),
  created () {
  },
  mounted () {
    this.clear()
    // 元画面（受付入力）で読み込み済み（受付入力以外から呼ばれるようになるのであれば使う）
    // this.loadMasters()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      jininList: 'DDMasters/mstJinin',
      loginUserId: 'users/userId',
      tgMstHinmeiList: 'DDMasters/vwCMstHinmeiExtTg',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    sonotaHinmokuList () {
      if (!this.uketsukeBuzaiList) return []
      return this.uketsukeBuzaiList.filter((elem) => {
        return elem.himodukeId !== null
      }).sort((a, b) => {
        return a.himodukeId - b.himodukeId
      })
    },
    targetSeikyuTanka () {
      const seikyuRankSbt = this.shubetsuList.find((elem) => elem.sbtShuruiCd === 'SBT003' && elem.sbtCd === this.seikyuRank)
      if (seikyuRankSbt) {
        return seikyuRankSbt.komoku2
      }
      return null
    },
    filteredShiharaiRankSbt () {
      return this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT004')
    },
    filteredSagyoBuzaiHinmeiList () {
      return this.tgMstHinmeiList.filter((elem) => elem.hinshuSbt === '02' || elem.hinshuSbt === '03')
    },
    hinmokuList () {
      const list = []
      if (this.filteredSagyoBuzaiHinmeiList && this.filteredSagyoBuzaiHinmeiList.length > 0) {
        this.filteredSagyoBuzaiHinmeiList.forEach((elem) => {
          const index = this.uketsukeBuzaiList.findIndex((hinmoku) => (hinmoku.mitsumoriSeikyuTanka !== null || hinmoku.buzaiSeikyuTanka !== null) && hinmoku.mstHinmeiId === elem.id)
          var tanka = 0
          if (index !== -1) tanka = this.uketsukeBuzaiList[index].buzaiSeikyuTanka ?? this.uketsukeBuzaiList[index].mitsumoriSeikyuTanka
          else if (this.targetSeikyuTanka) tanka = (elem[this.targetSeikyuTanka] ?? 0)
          list.push({
            mstHinmeiId: elem.id,
            himodukeId: null,
            hinmokuCd: elem.id + '_null',
            hinmokuNm: elem.hinmeiNm,
            seikyuTanka: (tanka ?? 0),
            shiharaiTanka0: null,
            shiharaiTanka1: (elem.shiharaiTanka1 ?? 0),
            shiharaiTanka2: (elem.shiharaiTanka2 ?? 0),
            shiharaiTanka3: (elem.shiharaiTanka3 ?? 0),
            shiharaiTanka4: (elem.shiharaiTanka4 ?? 0),
            shiharaiTanka5: (elem.shiharaiTanka5 ?? 0),
            hyojunTanka: elem.tanka,
            hinban: elem.hinban,
            katashiki: elem.katashiki,
            unitKbn: elem.unitKbn,
            hinmokuSbt: elem.hacchusakiHinshuKbn
          })
        })
      }
      if (this.sonotaHinmokuList && this.sonotaHinmokuList.length > 0) {
        this.sonotaHinmokuList.forEach((elem) => {
          list.push({
            mstHinmeiId: null,
            himodukeId: elem.himodukeId,
            hinmokuCd: 'null_' + elem.himodukeId,
            hinmokuNm: elem.hinmokuNm,
            seikyuTanka: elem.buzaiSeikyuTanka ?? elem.mitsumoriSeikyuTanka ?? elem.seikyuTanka,
            shiharaiTanka0: elem.shiharaiTanka,
            shiharaiTanka1: null,
            shiharaiTanka2: null,
            shiharaiTanka3: null,
            shiharaiTanka4: null,
            shiharaiTanka5: null,
            hyojunTanka: elem.hyojunTanka,
            hinban: elem.hinban,
            katashiki: elem.katashiki,
            unitKbn: elem.unitKbn,
            hinmokuSbt: elem.hinmokuSbt
          })
        })
      }
      return list
    },
    filteredRows () {
      const self = this
      return this.rows.filter((elem) => {
        if (this.filterSharyoSagyoMikanryoFlg && elem.sagyoKanryoFlg) return false
        elem.delFlg = (elem.delFlg) ? elem.delFlg : false
        return true
      }).map((elem, index) => {
        elem.index = index + 1
        // 依頼備考略称
        elem.sharyoBikoAbbr = [undefined, null].includes(elem.sharyoBiko) || elem.sharyoBiko.length <= 20 ? elem.sharyoBiko : elem.sharyoBiko.substring(0, 20) + '...'
        // 依頼先略称
        elem.iraisakiNmAbbr = [undefined, null].includes(elem.iraisakiNm) || elem.iraisakiNm.length <= 5 ? elem.iraisakiNm : elem.iraisakiNm.substring(0, 5) + '...'
        // 実施者略称
        elem.sagyoJisshishaNmAbbr = [undefined, null].includes(elem.sagyoJisshishaNm) || elem.sagyoJisshishaNm.length <= 5 ? elem.sagyoJisshishaNm : elem.sagyoJisshishaNm.substring(0, 5) + '...'
        // 作業予定日編集
        if (![undefined, null, ''].includes(elem.sagyoYoteiYmdFrom)) {
          elem.sagyoYoteiYmdDisp = (filter.dateFormatter(elem.sagyoYoteiYmdFrom)).substring(2, 10)
        }
        if (![undefined, null, ''].includes(elem.sagyoYoteiYmdTo)) {
          elem.sagyoYoteiYmdDisp = elem.sagyoYoteiYmdDisp + '～' + (filter.dateFormatter(elem.sagyoYoteiYmdTo)).substring(2, 10)
        }
        // 依頼備考略称
        elem.sagyoMemoAbbr = [undefined, null].includes(elem.sagyoMemo) || elem.sagyoMemo.length <= 20 ? elem.sagyoMemo : elem.sagyoMemo.substring(0, 20) + '...'

        // 請求金額合計
        const tmp = ((elem.seikyuSagyoKingakuKei) && elem.seikyuSagyoKingakuKei !== null ? parseInt(elem.seikyuSagyoKingakuKei, 10) : '') + ((elem.seikyuBuzaiKingakuKei) && elem.seikyuBuzaiKingakuKei !== null ? parseInt(elem.seikyuBuzaiKingakuKei, 10) : '')
        self.$set(elem, 'seikyuKingakuKeiDisp', tmp !== '' ? filter.numericFormatter(tmp) : '')
        // 支払金額合計
        elem.shiharaiKingakuKeiDisp = (elem.shiharaiSagyoKingakuKei) && elem.shiharaiSagyoKingakuKei !== null ? filter.numericFormatter(elem.shiharaiSagyoKingakuKei) : ''

        return elem
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredShohinList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.hinshuSbt === '01' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    filteredTantoshaList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        const jisha = self.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredShashinRows () {
      return this.shashinRows.map((elem) => {
        if (elem.sagyoImageKbn === '01') elem.sagyoImageText = 'チェックシート'
        if (elem.sagyoImageKbn === '02') elem.sagyoImageText = 'フロント'
        if (elem.sagyoImageKbn === '03') elem.sagyoImageText = '写真' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        if (elem.sagyoImageKbn === '04') elem.sagyoImageText = '領収書：' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '0' : elem.sagyoImageText) + '円'
        if (elem.sagyoImageKbn === '11') elem.sagyoImageText = '取付作業前' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        if (elem.sagyoImageKbn === '12') elem.sagyoImageText = '取付作業中' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        if (elem.sagyoImageKbn === '13') elem.sagyoImageText = '取付作業後' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        if (elem.sagyoImageKbn === '21') elem.sagyoImageText = '取外作業前' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        if (elem.sagyoImageKbn === '22') elem.sagyoImageText = '取外作業中' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        if (elem.sagyoImageKbn === '23') elem.sagyoImageText = '取外作業後' + ([undefined, null, ''].includes(elem.sagyoImageText) ? '' : '：' + elem.sagyoImageText)
        elem.sagyoImageKbnNum = Number(elem.sagyoImageKbn)
        return elem
      }).sort((a, b) => {
        if (a.sagyoImageKbn - a.sagyoImageKbn !== 0) { return a.sagyoImageKbn - a.sagyoImageKbn }
        return a.sagyoImageNo - b.sagyoImageNo
      })
    },
    // DropDownList
    filteredSagyoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'TGK001')
    },
    filteredSharyoMakerList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS004')
    },
    filteredBackEyeFormatList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS005')
    },
    filteredEtcFormatList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS006')
    },
    filteredRefrigeratorMakerList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS007')
    },
    // sticky
    tableWidthStyle () {
      const obj = {}
      this.stickyWidth.forEach((elem, idx) => {
        obj[`--width-of-${idx + 1}`] = elem + 'px'
      })
      return obj
    },
    isDisableSagyoIrai () {
      return this.selected.length <= 0
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.setHeaders()
        this.initialize()
      }
    },
    searchText: function () {
      this.$nextTick(() => { this.onResize() })
    },
    filterSharyoSagyoMikanryoFlg: function () {
      this.$nextTick(() => { this.onResize() })
    }
  },
  methods: {
    onResize: function () {
      if (this.showDialog) {
        this.calcWidthLineHeader()
      }
    },
    calcWidthLineHeader () {
      var i
      var key
      var tw = 0
      const t = new Array(10)
      for (i = 0; i < 10; i++) {
        key = 'tableLineHeader' + i
        var ele = document.getElementById(key)
        if (ele) {
          var rect = ele.getBoundingClientRect()
          tw += rect.width
        }
        t[i] = tw
      }
      if (t.toString() !== this.stickyWidth.toString()) {
        console.log('width changed')
        this.stickyWidth = t
      }
    },
    getCloneTargetMethod: function () {
      return {
        rows: this.rows
      }
    },
    setCloneData: function () {
      this.cloneData = dolly.clone(this.getCloneTargetMethod())
    },
    clear: function () {
      this.rows = []
      this.searchText = ''
      this.filterSharyoSagyoMikanryoFlg = false
    },
    getTargetShiharaiTanka: function (sbtCd) {
      const shiharaiRankSbt = this.filteredShiharaiRankSbt.find((elem) => elem.sbtCd === sbtCd)
      if (shiharaiRankSbt) {
        return shiharaiRankSbt.komoku2
      }
      return null
    },
    initialize () {
      if (this.showDialog) {
        // const self = this
        this.selected = []
        this.setSharyoRows()
        this.$nextTick(function () {
          this.setCloneData()
          this.calcWidthLineHeader()
        })
      }
    },
    setHeaders: function () {
      this.headers = [
        // { text: '', value: 'data-table-select', thId: 'tableLineHeader0', thClass: 'stickyh0 px-0', tdClass: 'sticky0 px-0' },
        { text: '', value: 'jissekiMikakuninFlg', thId: 'tableLineHeader1', thClass: 'stickyh1 px-0', tdClass: 'sticky1 px-0' },
        { text: '#', value: 'keyNo', thId: 'tableLineHeader2', thClass: 'stickyh2', tdClass: 'sticky2' },
        { text: '操作', value: 'actions', thId: 'tableLineHeader3', thClass: 'stickyh3', tdClass: 'sticky3', sortable: false },
        { text: '作業予定日', value: 'sagyoYoteiYmdDisp', thId: 'tableLineHeader4', thClass: 'stickyh4', tdClass: 'sticky4 input' },
        { text: '作業実施日', value: 'jissekiSagyoYmdDisp', thId: 'tableLineHeader5', thClass: 'stickyh5', tdClass: 'sticky5 input' },
        { text: '案件番号', value: 'refAnkenNo', thId: 'tableLineHeader6', thClass: 'stickyh6', tdClass: 'sticky6 input' },
        { text: '作業依頼先', value: 'iraisakiNm', thId: 'tableLineHeader7', thClass: 'stickyh7', tdClass: 'sticky7 input' },
        { text: '作業実施者', value: 'sagyoJisshishaNm', thId: 'tableLineHeader8', thClass: 'stickyh8', tdClass: 'sticky8 input' },
        { text: '新車番プレートNo', value: 'newShabanPlateNo', thId: 'tableLineHeader9', thClass: 'stickyh9', tdClass: 'sticky9 input' },
        { text: '作業備考', value: 'sagyoMemo', thId: '', thClass: '', tdClass: 'input' },
        // { text: 'チェックシート回収', value: 'checksheetsKaishuFlgDisp', thId: '', thClass: 'verticalHeader', tdClass: '' },
        // { text: 'チェックシート報告', value: 'checksheetsHokokuFlgDisp', thId: '', thClass: 'verticalHeader', tdClass: '' },
        // { text: '請求書発注No', value: 'seikyushoHacchuNo', thId: '', thClass: '', tdClass: '' },
        // { text: '金額', value: 'seikyuKingakuDisp', thId: '', thClass: '', tdClass: '' },
        // { text: '発注金額（外注）', value: 'shiharaiKingakuDisp', thId: '', thClass: '', tdClass: '' },
        { text: '作業完了☑', value: 'sagyoKanryoFlg', thId: '', thClass: 'verticalHeader', tdClass: '' },
        // { text: '作業完了確認担当者', value: 'sagyoKanryoKakuninTantoshaNm', thId: '', thClass: '', tdClass: this.uketsukeShoukaiFlg ? '' : 'input' },
        // { text: '作業完了確認日', value: 'sagyoKanryoKakuninYmdDisp', thId: '', thClass: '', tdClass: this.uketsukeShoukaiFlg ? '' : 'input' }
        { text: '売上確定☑', value: 'uriageKakuteiFlg', thId: '', thClass: 'verticalHeader', tdClass: '' },
        { text: '弥生連携不要☑', value: 'notYayoiRenkeiFlg', thId: '', thClass: 'verticalHeader', tdClass: '' },
        { text: '社長請求☑', value: 'matomeSeikyuFlg', thId: '', thClass: 'verticalHeader', tdClass: '' },
        { text: '作業キャンセル☑', value: 'sagyoCancelFlg', thId: '', thClass: 'verticalHeader', tdClass: '' },
        { text: 'OPS未完☑', value: 'notOpsUploadFlg', thId: '', thClass: 'verticalHeader', tdClass: '' },
        { text: '売上締め', value: 'uriageClosingStatus', thId: '', thClass: 'verticalHeader', tdClass: '' },
        { text: '支払締め', value: 'shiharaiClosingStatus', thId: '', thClass: 'verticalHeader', tdClass: '' }
      ]
      /**
       * 作業・部材列
       */
      this.hinmokuList.sort((a, b) => {
        if (a.hinmokuSbt !== b.hinmokuSbt) return this.getNumber(a.hinmokuSbt) - this.getNumber(b.hinmokuSbt)
        if (a.mstHinmeiId) return a.mstHinmeiId - b.mstHinmeiId
        return a.himodukeId - b.himodukeId
      }).forEach((elem) => {
        if (this.isShowSagyoColumn) {
          for (let i = 0; i < this.uketsukeSagyoList.length; i++) {
            if (elem.mstHinmeiId === this.uketsukeSagyoList[i].mstHinmeiId) {
              this.headers.push({ text: elem.hinmokuNm, value: 'option' + elem.mstHinmeiId, thId: '', thClass: 'verticalHeaderOption', tdClass: this.uketsukeShoukaiFlg ? '' : 'input' })
            }
          }
        }
      })
      /* 請求金額・支払金額 */
      this.headers.push({ text: '請求金額', value: 'seikyuKingakuKei', thId: '', thClass: 'textBoxWidthS', tdClass: 'rightInput', align: 'end' })
      this.headers.push({ text: '支払金額', value: 'shiharaiKingakuKei', thId: '', thClass: 'textBoxWidthS', tdClass: 'rightInput', align: 'end' })

      this.hinmokuList.sort((a, b) => {
        if (a.hinmokuSbt !== b.hinmokuSbt) return this.getNumber(a.hinmokuSbt) - this.getNumber(b.hinmokuSbt)
        if (a.mstHinmeiId) return a.mstHinmeiId - b.mstHinmeiId
        return a.himodukeId - b.himodukeId
      }).forEach((elem) => {
        if (this.isShowBuzaiColumn) {
          for (let i = 0; i < this.uketsukeBuzaiList.length; i++) {
            if (elem.mstHinmeiId === this.uketsukeBuzaiList[i].mstHinmeiId) {
              this.headers.push({ text: elem.hinmokuNm, value: 'buzai' + elem.mstHinmeiId, thId: '', thClass: 'verticalHeaderBuzai', tdClass: this.uketsukeShoukaiFlg ? '' : 'input' })
            }
          }
        }
      })

      /**
       * 補足情報
       */
      if (this.isShowAppendixColumn) {
        this.headers.push({ text: '旧車番プレートNo', value: 'oldShabanPlateNo', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: '車両備考', value: 'sharyoBiko', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: '車台番号', value: 'newShadaiNo', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: '車両型式', value: 'sharyoKeishiki', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: '車両メーカー', value: 'sharyoMaker', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: '車種', value: 'shashu', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: 'バックアイメーカー', value: 'backeyeKeishiki', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: 'ETCメーカー', value: 'etcKeishiki', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: '冷凍機メーカー', value: 'refrigeratorMaker', thId: '', thClass: '', tdClass: 'input' })
        this.headers.push({ text: 'ドア番', value: 'doorNo', thId: '', thClass: '', tdClass: 'input' })
      }

      // 列幅再計算
      this.$nextTick(function () {
        this.calcWidthLineHeader()
      })
    },
    setSharyoRows () {
      this.rows = []
      this.rows = this.uketsukeSharyoList.sort((a, b) => {
        return a.keyNo - b.keyNo
      }).map((elem) => {
        elem = {
          ...elem
        }
        // オプション作業
        this.uketsukeSharyoOptionList.filter(function (opt) {
          return opt.keyNo === elem.keyNo
        }).forEach((item) => {
          elem['option' + item.mstHinmeiId] = item.juchuSuryo
          elem['option' + item.mstHinmeiId + 'tanka'] = filter.numericFormatter(item.shohinTanka ? item.shohinTanka : 0)
        })
        // 部材
        this.uketsukeSharyoBuzaiList.filter(function (opt) {
          return opt.keyNo === elem.keyNo
        }).forEach((item) => {
          elem['buzai' + item.mstHinmeiId] = item.juchuSuryo
          elem['buzai' + item.mstHinmeiId + 'tanka'] = filter.numericFormatter(item.shohinTanka ? item.shohinTanka : 0)
        })
        return elem
      })
    },

    getCurrentYmdString: function () {
      return filter.dateFormatter(new Date())
    },
    registerValidate: function () {
      return true
    },
    getNumber (value) {
      if (!value) {
        return 0
      } else if (isFinite(value)) {
        if (typeof value === 'number') {
          return value
        } else {
          return parseFloat(value)
        }
      } else if (typeof value === 'string') {
        const num = value.replace(/,/g, '')
        if (isFinite(num)) {
          return parseFloat(num)
        }
      }
      return 0
    },
    onSaveButtonClick: function (e) {
      this.syncSagyoSharyo()
    },
    syncSagyoSharyo: function () {
      this.syncSagyoInput()
      this.$emit('edited', this.rows, this.uketsukeSharyoKihonList, this.uketsukeSharyoOptionList, this.uketsukeSharyoBuzaiList)
    },
    closeDialog () {
      this.$emit('close')
    },
    onCloseButtonClick: function (e) {
      // 変更チェック
      const target = this.getCloneTargetMethod()
      const modified = this._compareClone(target)
      const p = modified ? modals.showConfirmYesNoCancelCustom : this._dummyPromiseMethod
      if (p !== this._dummyPromiseMethod) {
        p('TGRCOQ09', null, null, null, '保存して閉じる', '保存しないで閉じる').then((result) => {
          if (result.isConfirmed) {
            // 保存して閉じる
            this.syncSagyoSharyo()
          } else if (result.isDenied) {
            // 保存しないで閉じる
            this.closeDialog()
          } else {
            // 何もしない
            return false
          }
        })
      } else {
        this.closeDialog()
      }
    },
    onSagyoImageDialogOpenClick: function (item) {
      this.sagyoImageJissekiId = item.trSagyoJissekiId
      this.sagyoImageTargetItem = item
      this.setShashinRows()
      this.showImageDialog = true
    },
    onSharyoDelete: function (item) {
      const index = this.rows.indexOf(item)
      this.recSharyo = Object.assign({}, item)
      this.recSharyo.delFlg = !this.recSharyo.delFlg
      Object.assign(this.rows[index], this.recSharyo)
      this.rows.splice()
    },
    setShashinRows: function (e) {
      if (this.sagyoImageJissekiId) {
        // 作業写真を取得してshashinRowsに入れる。
        const self = this
        return new Promise((resolve) => {
          self.HttpClient
            .get(`/api/v1/TgRcod002010/GetSagyoImage?id=${self.sagyoImageJissekiId}`)
            .then((data) => {
              console.log('sagyoImage', data)
              if (data.isValid) {
                self.shashinRows = data.payload.map((elem) => {
                  const sagyoImageFileNmSplit = (elem.sagyoImageFileNm ?? '').split('.')
                  const sagyoImageFileExtention = sagyoImageFileNmSplit[sagyoImageFileNmSplit.length - 1]
                  return {
                    ...elem,
                    content: `/api/v1/trTgSagyoImage/Image?id=${elem.id}&date=${new Date()}`,
                    fileKbn: IMAGE_EXTENTION_LIST.includes(sagyoImageFileExtention) ? 'img' : 'noImg'
                  }
                })
              }
              resolve()
            }).catch((e) => {
              console.log('error', e)
              modals.showError(e.message)
              resolve()
            })
        })
      } else {
        this.shashinRows = []
      }
    },
    onImageDialogCloseButtonClick: function () {
      // const targetIndex = this.rows.findIndex((elem) => elem.id === this.sagyoImageTargetItem.id)
      // this.rows[targetIndex].sagyoJissekiId = this.sagyoImageJissekiId
      this.shashinRows = []
      this.showImageDialog = false
    },
    onShashinHimodukeDialogOpenClick: function () {
      this.shashinHimodukeParam.hacchuKihonId = this.sagyoImageTargetItem.trHacchuKihonId
      this.shashinHimodukeParam.sagyoJissekiId = this.sagyoImageJissekiId
      this.himodukeSagyoMeisaiId = this.sagyoImageTargetItem.id
      this.showShashinHimodukeDialog = true
    },
    onImageOpenButtonClick: function (item) {
      if (item && item.content) {
        window.open(item.content)
      }
    },
    onSagyoImagePdfDownload: function (item) {
      this.HttpClient
        .requestFile(`/api/v1/trTgSagyoImage/Pdf?id=${item.id}`)
        .then((data) => {
          console.log(data)
          const blob = new Blob([data], { type: 'application/octet-stream' })
          const elem = document.getElementById('sagyoImageDownload')
          elem.href = window.URL.createObjectURL(blob)
          const fileNmSplit = item.sagyoImageFileNm.split('/')
          elem.download = fileNmSplit[fileNmSplit.length - 1]
          elem.click()
        })
        .catch((e) => {
          console.log('error', e)
          modals.showError(e.message)
        })
    },
    onImageDeleteButtonClick: function (item) {
      modals.showConfirm('TGRCOQ16').then((ok) => {
        if (ok !== false && ok !== undefined) {
          const self = this
          this.HttpClient
            .delete(`/api/v1/trTgSagyoImage/Delete?id=${item.id}&tm=${item.timestamp}`)
            .then((data) => {
              // 該当行を削除
              const index = self.shashinRows.findIndex((elem) => elem.id === item.id)
              self.shashinRows.splice(index, 1)
              // 対象車両のチェックリスト数を減算
              const index2 = self.rows.findIndex((elem) => elem.trSagyoJissekiId === item.trSagyoJissekiId)
              if (index2 >= 0) {
                self.rows[index2].checksheetCount -= 1
              }
            })
            .catch((e) => {
              console.log('error', e)
              modals.showError(e.message)
            })
        }
      })
    },
    onShashinHimodukeDialogClose: function (id) {
      if (this.recSharyo.trSagyoJissekiId !== id) {
        this.recSharyo.trSagyoJissekiId = id
        this.setShashinRows()
      }
      this.showShashinHimodukeDialog = false
    },
    onShowSagyoColumn: function () {
      this.isShowSagyoColumn = !this.isShowSagyoColumn
      this.setHeaders()
    },
    onShowBuzaiColumn: function () {
      this.isShowBuzaiColumn = !this.isShowBuzaiColumn
      this.setHeaders()
    },
    onShowAppendixColumn: function () {
      this.isShowAppendixColumn = !this.isShowAppendixColumn
      this.setHeaders()
    },

    /**
     * 車両編集
     */
    onPopupSagyoSharyoEditOpen: function (rowIndex) {
      this.syncSagyoInput()

      this.sharyoParam = {
        ...this.sharyoParam,
        unchinKakuteiFlg: this.cloneSeikyuKakuteiFlg,
        seikyuRank: null,
        sagyoKbn: this.param.sagyoKbn,
        shohinId: this.param.shohinId,
        uketsukeSharyoList: this.rows,
        uketsukeKihonList: this.uketsukeSharyoKihonList,
        uketsukeSagyoList: this.uketsukeSharyoOptionList,
        uketsukeBuzaiList: this.uketsukeSharyoBuzaiList,
        useRefAnkenNo: this.param.useRefAnkenNo,
        index: rowIndex - 1
      }
      this.isShowPopupSagyoSharyoEdit = true
    },
    onPopupSagyoSharyoEditClose: function () {
      this.isShowPopupSagyoSharyoEdit = false
    },
    onSharyoEdited: function (x, a, b, c) {
      console.log('onSharyoEdited', x, a, b, c)
      this.uketsukeSharyoList = x
      this.uketsukeSharyoKihonList = a
      this.uketsukeSharyoOptionList = b
      this.uketsukeSharyoBuzaiList = c

      this.setSharyoRows()

      this.isShowPopupSagyoSharyoEdit = false
    },

    /**
     * 作業キャンセル
     */
    onCheckSagyoCancelFlg: function (item) {
      if (item.sagyoCancelFlg) {
        var wDate = date.getCurrentDate()
        if (![undefined, null, ''].includes(item.sagyoYoteiYmdFrom)) {
          wDate = filter.dateFormatter(item.sagyoYoteiYmdFrom)
        } else if (![undefined, null, ''].includes(item.sagyoYoteiYmdTo)) {
          wDate = filter.dateFormatter(item.sagyoYoteiYmdTo)
        }
        item.sagyoCancelYmd = wDate
      } else {
        item.sagyoCancelYmd = null
      }
    },

    /**
     * 社長請求
     */
    onCheckMatomeSeikyuFlg: function (item) {
      if (item.matomeSeikyuFlg) {
        item.uriageKakuteiFlg = true
        item.notYayoiRenkeiFlg = true
      }
    },

    /**
     * 作業・部材データ反映
     */
    syncSagyoInput () {
      let row = []
      const self = this
      for (row of self.rows) {
        // 差分チェック
        const cloneRowsIndex = self.cloneData.rows.findIndex(x => x.id === row.id)
        const t1 = JSON.stringify(row)
        const c1 = JSON.stringify(this.cloneData.rows[cloneRowsIndex])
        if (t1 !== c1) {
          row.editFlg = true
        }

        const cols = Object.keys(row)
        cols.forEach(function (elem) {
          console.log('syncSagyoInput 1', elem)
          if (elem.startsWith('option')) {
            const index = self.uketsukeSharyoOptionList.findIndex((hinmoku) => (hinmoku.keyNo === row.keyNo && 'option' + hinmoku.mstHinmeiId === elem.replace('tanka', '')))
            console.log(index)
            if (index >= 0) {
              console.log('syncSagyoInput 2 <', elem, '>')
              if (!elem.endsWith('tanka')) {
                console.log('syncSagyoInput option suryo [', elem, '] ', row[elem])
                self.uketsukeSharyoOptionList[index].juchuSuryo = row[elem]
                // 数量が0の場合は支払金額も0にする
                if ([undefined, null, 0, '0'].includes(row[elem])) {
                  self.uketsukeSharyoOptionList[index].shohinTanka = 0
                  self.uketsukeSharyoOptionList[index].shohinTankaDisp = 0
                  self.uketsukeSharyoOptionList[index].seikyuKingaku = 0
                  self.uketsukeSharyoOptionList[index].shiharaiKingaku = ![undefined, null].includes(self.uketsukeSharyoOptionList[index].shiharaiKingaku) ? 0 : null
                }
              } else {
                console.log('syncSagyoInput option tanka [', elem, '] ', row[elem.replace('tanka', '')], '*', row[elem])
                self.uketsukeSharyoOptionList[index].shohinTanka = [undefined, null, 0, '0'].includes(row[elem.replace('tanka', '')]) ? 0 : formatter.removeComma(row[elem])
                self.uketsukeSharyoOptionList[index].shohinTankaDisp = [undefined, null, 0, '0'].includes(row[elem.replace('tanka', '')]) ? 0 : row[elem]
                self.uketsukeSharyoOptionList[index].seikyuKingaku = row[elem.replace('tanka', '')] * formatter.removeComma(row[elem])
              }
            }
          }
          if (elem.startsWith('buzai')) {
            const index = self.uketsukeSharyoBuzaiList.findIndex((hinmoku) => (hinmoku.keyNo === row.keyNo && 'buzai' + hinmoku.mstHinmeiId === elem.replace('tanka', '')))
            console.log(index)
            if (index >= 0) {
              if (!elem.endsWith('tanka')) {
                console.log('syncSagyoInput buzai suryo [', elem, '] ', row[elem])
                self.uketsukeSharyoBuzaiList[index].juchuSuryo = row[elem]
                // 数量が0の場合は支払金額も0にする
                if ([undefined, null, 0, '0'].includes(row[elem])) {
                  self.uketsukeSharyoBuzaiList[index].shohinTanka = 0
                  self.uketsukeSharyoBuzaiList[index].shohinTankaDisp = 0
                  self.uketsukeSharyoBuzaiList[index].seikyuKingaku = 0
                  self.uketsukeSharyoBuzaiList[index].shiharaiKingaku = ![undefined, null].includes(self.uketsukeSharyoOptionList[index].shiharaiKingaku) ? 0 : null
                }
              } else {
                console.log('syncSagyoInput buzai tanka [', elem, '] ', row[elem.replace('tanka', '')], '*', row[elem])
                self.uketsukeSharyoBuzaiList[index].shohinTanka = formatter.removeComma(row[elem])
                self.uketsukeSharyoBuzaiList[index].shohinTankaDisp = row[elem]
                self.uketsukeSharyoBuzaiList[index].seikyuKingaku = row[elem.replace('tanka', '')] * formatter.removeComma(row[elem])
              }
            }
          }
        })
      }
    },
    // 金額計算
    calcSeikyuKingaku: function (e, item) {
      console.log('calcSeikyuKingaku', item)
      const cols = Object.keys(item)
      let seikyuKingakuGokei = 0
      cols.forEach(function (elem) {
        if (elem.endsWith('tanka')) {
          seikyuKingakuGokei = seikyuKingakuGokei + (item[elem.replace('tanka', '')] * formatter.removeComma(item[elem]))
        }
      })
      this.$nextTick(() => {
        this.$set(item, 'seikyuKingakuKeiDisp', filter.numericFormatter(seikyuKingakuGokei))
      })
    },
    /**
     * コピー
     */
    onSharyoCopy: function (index) {
      // 先頭行は1から始まる為、-1
      if (index > 1) {
        const self = this
        const cols = Object.keys(this.rows[index - 1])
        cols.forEach(function (elem) {
          if (elem.startsWith('jissekiSagyoYmd') ||
              elem.startsWith('newShabanPlateNo') ||
              elem.startsWith('sharyoMaker') ||
              elem.startsWith('shashu') ||
              elem.startsWith('backeyeKeishiki') ||
              elem.startsWith('etcKanriNo') ||
              elem.startsWith('etcKeishiki') ||
              elem.startsWith('refrigeratorMaker') ||
              elem.startsWith('option') ||
              elem.startsWith('buzai')) {
            self.rows[index - 1][elem] = self.rows[index - 2][elem]
          }
        })
        this.rows.splice()
      }
    },

    /**
     * 表示制御
     */
    onSwitchExpandColumn: function () {
      this.isExpandColumn = !this.isExpandColumn
      this.$nextTick(function () {
        this.calcWidthLineHeader()
      })
    },
    getClass (item) {
      var classString = ''
      // 列固定
      if (item === 'data-table-select') {
        classString = 'stickyh0'
      }
      if (item === 'jissekiMikakuninFlg') {
        classString = 'stickyh1'
      }
      if (item === 'keyNo') {
        classString = 'stickyh2'
      }
      if (item === 'actions') {
        classString = 'stickyh3'
      }
      if (item === 'sagyoYoteiYmdDisp') {
        classString = 'stickyh4'
      }
      if (item === 'jissekiSagyoYmdDisp') {
        classString = 'stickyh5'
      }
      if (item === 'refAnkenNo') {
        classString = 'stickyh6'
      }
      if (item === 'iraisakiNm') {
        classString = 'stickyh7'
      }
      if (item === 'sagyoJisshishaNm') {
        classString = 'stickyh8'
      }
      if (item === 'newShabanPlateNo') {
        classString = 'stickyh9'
      }

      if (item === 'data-table-select' || item === 'jissekiMikakuninFlg' || item === 'keyNo') {
        classString = classString + ' px-0 textBoxWidthMin'
      } else if (item === 'actions') {
        classString = classString + (classString === '' ? '' : ' ') + 'textBoxWidthMin'
      } else if (item === 'sagyoYoteiYmdDisp') {
        classString = classString + (classString === '' ? '' : ' ') + 'textBoxWidthSS'
      } else if (item === 'jissekiSagyoYmdDisp') {
        classString = classString + (classString === '' ? '' : ' ') + 'textBoxWidthSSS'
      } else if (['seikyuKingakuKei', 'shiharaiKingakuKei'].includes(item)) {
        classString = classString + (classString === '' ? '' : ' ') + 'textBoxWidthSSS'
      } else if (['sagyoKanryoFlg', 'uriageKakuteiFlg', 'sagyoCancelFlg', 'matomeSeikyuFlg', 'notYayoiRenkeiFlg', 'notOpsUploadFlg', 'uriageClosingStatus', 'shiharaiClosingStatus'].includes(item)) {
        classString = classString + (classString === '' ? '' : ' ') + 'verticalHeader'
      } else if (['iraisakiNm', 'sagyoJisshishaNm'].includes(item)) {
        classString = classString + (classString === '' ? '' : ' ') + (this.isExpandColumn ? 'textBoxWidthM' : 'verticalHeaderM')
      } else if (['sagyoMemo', 'refAnkenNo'].includes(item)) {
        classString = classString + (classString === '' ? '' : ' ') + (this.isExpandColumn ? 'textBoxWidthL' : 'textBoxWidthSSS')
      } else if (item.startsWith('option')) {
        classString = classString + (classString === '' ? '' : ' ') + (this.isShowAppendixColumn ? 'verticalHeaderOptionW' : 'verticalHeaderOption')
      } else if (item.startsWith('buzai')) {
        classString = classString + (classString === '' ? '' : ' ') + (this.isShowAppendixColumn ? 'verticalHeaderBuzaiW' : 'verticalHeaderBuzai')
      } else if (['oldShabanPlateNo', 'newShadaiNo', 'sharyoBiko', 'sharyoKeishiki', 'sharyoMaker', 'shashu', 'backeyeKeishiki', 'etcKeishiki', 'refrigeratorMaker', 'doorNo'].includes(item)) {
        classString = classString + (classString === '' ? '' : ' ') + 'verticalHeaderAppendix'
      } else {
        classString = classString + (classString === '' ? '' : ' ') + (this.isExpandColumn ? 'textBoxWidthM' : 'verticalHeaderM')
      }

      return classString
    },

    /**
     * 作業依頼
     */
    onSagyoIraiClick: function () {
      // 変更チェック
      const target = this.getCloneTargetMethod()
      const modified = this._compareClone(target)
      const p = modified ? modals.showConfirmYesNo : this._dummyPromiseMethod
      if (p !== this._dummyPromiseMethod) {
        p('TGRCOQ09').then((ok) => {
          if (ok === false || ok === undefined) {
            modals.showToast('内容が変更されている為、<br>この操作を実行するには保存が必要です', 1800, 400, 'center', 'warning')
            return false
          } else {
            this.syncSagyoSharyo()
            this.$emit('saverequest', this.rows, this.uketsukeSharyoKihonList, this.uketsukeSharyoOptionList, this.uketsukeSharyoBuzaiList, this.selected)
          }
        })
      } else {
        this.$emit('request', this.selected)
      }
    },

    /**
     * インポート／ダウンロード
     */
    onSharyoJohoInputButtonClick: function () {
      this.$refs.sharyoTorikomiFile.$refs.input.click()
    },
    onSharyoJohoFileChanged: function () {
      console.log(this.sharyoTorikomiFile)
      if (this.sharyoTorikomiFile !== undefined && this.sharyoTorikomiFile !== null) {
        if (this.sharyoTorikomiFile.type !== 'text/csv') {
          modals.showAlert('COME0020').then(() => {})
          this.sharyoTorikomiFile = null
        } else {
          this.Effects.loadStart()

          // CSVファイルをSHIFT-JIS文字列として取得
          const self = this
          const csvFile = new FileReader()
          csvFile.readAsText(self.sharyoTorikomiFile, 'shift-jis')
          csvFile.addEventListener('load', () => {
            const csvFileLineData = csvFile.result.split(/\r\n|\n/)
            for (var rowIndex = 1; rowIndex < csvFileLineData.length; rowIndex++) {
              if (csvFileLineData[rowIndex] !== '') {
                const csvFileLineColumnData = csvFileLineData[rowIndex].split(',')
                if (csvFileLineColumnData[0] !== '') {
                  let targetIndex = self.rows.findIndex((item) => item.newShabanPlateNo === csvFileLineColumnData[0])
                  if (targetIndex >= 0) {
                    // 同一新車番プレートNoは上書き
                  } else {
                    // 未存在の場合は新車番プレートNoが空白の箇所に上書き
                    targetIndex = self.rows.findIndex((item) => item.newShabanPlateNo === '' || item.newShabanPlateNo === null)
                  }
                  if (targetIndex >= 0) {
                    self.rows[targetIndex].newShabanPlateNo = csvFileLineColumnData[0].replaceAll('"', '')
                    self.rows[targetIndex].oldShabanPlateNo = csvFileLineColumnData[1].replaceAll('"', '')
                    self.rows[targetIndex].newShadaiNo = csvFileLineColumnData[2].replaceAll('"', '')
                    self.rows[targetIndex].oldShadaiNo = csvFileLineColumnData[3].replaceAll('"', '')
                    self.rows[targetIndex].sharyoBiko = csvFileLineColumnData[4].replaceAll('"', '')
                    self.rows[targetIndex].sharyoKeishiki = csvFileLineColumnData[5].replaceAll('"', '')
                    self.rows[targetIndex].shonendoToroku = csvFileLineColumnData[6].replaceAll('"', '')
                    self.rows[targetIndex].sharyoMaker = csvFileLineColumnData[7].replaceAll('"', '') === '' ? null : csvFileLineColumnData[7].replaceAll('"', '')
                    if (self.rows[targetIndex].sharyoMaker && self.rows[targetIndex].sharyoMaker.length === 1) {
                      self.rows[targetIndex].sharyoMaker = self.rows[targetIndex].sharyoMaker = '0' + self.rows[targetIndex].sharyoMaker
                    }
                    self.rows[targetIndex].shashu = csvFileLineColumnData[8].replaceAll('"', '')
                    self.rows[targetIndex].backeyeKeishiki = csvFileLineColumnData[9].replaceAll('"', '') === '' ? null : csvFileLineColumnData[9].replaceAll('"', '')
                    if (self.rows[targetIndex].backeyeKeishiki && self.rows[targetIndex].backeyeKeishiki.length === 1) {
                      self.rows[targetIndex].backeyeKeishiki = self.rows[targetIndex].backeyeKeishiki = '0' + self.rows[targetIndex].backeyeKeishiki
                    }
                    // self.rows[targetIndex].etcKanriNo = csvFileLineColumnData[9].replaceAll('"', '')
                    self.rows[targetIndex].etcKeishiki = csvFileLineColumnData[10].replaceAll('"', '') === '' ? null : csvFileLineColumnData[10].replaceAll('"', '')
                    if (self.rows[targetIndex].etcKeishiki && self.rows[targetIndex].etcKeishiki.length === 1) {
                      self.rows[targetIndex].etcKeishiki = self.rows[targetIndex].etcKeishiki = '0' + self.rows[targetIndex].etcKeishiki
                    }
                    // self.rows[targetIndex].newSerialNo = csvFileLineColumnData[11].replaceAll('"', '')
                    // self.rows[targetIndex].oldSerialNo = csvFileLineColumnData[12].replaceAll('"', '')
                    self.rows[targetIndex].refrigeratorMaker = csvFileLineColumnData[11].replaceAll('"', '') === '' ? null : csvFileLineColumnData[11].replaceAll('"', '')
                    if (self.rows[targetIndex].refrigeratorMaker && self.rows[targetIndex].refrigeratorMaker.length === 1) {
                      self.rows[targetIndex].refrigeratorMaker = self.rows[targetIndex].refrigeratorMaker = '0' + self.rows[targetIndex].refrigeratorMaker
                    }
                    self.rows[targetIndex].doorNo = csvFileLineColumnData[12].replaceAll('"', '')
                  }
                }
              }
            }
            // 取込できなかった情報を確認
            let noImportCount = 0
            for (rowIndex = 1; rowIndex < csvFileLineData.length; rowIndex++) {
              if (csvFileLineData[rowIndex] !== '') {
                const csvFileLineColumnData = csvFileLineData[rowIndex].split(',')
                const keyNewShabanPlateNo = csvFileLineColumnData[0].replaceAll('"', '')
                if (keyNewShabanPlateNo !== '') {
                  const targetIndex = self.rows.findIndex((item) => item.newShabanPlateNo === keyNewShabanPlateNo)
                  if (targetIndex < 0) noImportCount++
                }
              }
            }
            let resultMesssage = 'CSVファイルを取り込みました。反映して確定してください。'
            if (noImportCount > 0) {
              resultMesssage = resultMesssage + '<br>尚、末尾 ' + noImportCount + ' 件は取込できませんでした。'
            }
            modals.showSuccess(resultMesssage, 700)

            this.Effects.loadComplete()
          })
        }
      }
    },
    onSharyoJohoOutputButtonClick: function () {
      if (!this.rows || this.rows.length < 1) {
        modals.showAlert('COMI0101').then(() => {})
      } else {
        this.HttpClient
          .requestFile(`/api/v1/Tgrcod0021/SharyoCsvDownload?id=${this.id}`)
          .then((data) => {
            if (data.isValid !== undefined) {
              this.showMessage(data)
            } else {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const blob = new Blob([data], { type: 'text/csv' })
              const elem = document.getElementById('sharyoDownload')
              elem.href = window.URL.createObjectURL(blob)
              elem.download = '車両情報_' + ts + '.csv'
              elem.click()
            }
          })
          .catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
          })
      }
    },

    // 車両一括編集
    onPopupSagyoSharyoListEditOpen: function () {
      this.isShowPopupSagyoSharyoListEdit = true
    },
    onPopupSagyoSharyoListEditClose: function () {
      this.isShowPopupSagyoSharyoListEdit = false
    },
    onPopupSagyoSharyoListEditSave: function (items) {
      const self = this
      console.log('onPopupSagyoSharyoListEditSave', items)
      items.forEach((item) => {
        const targetIndex = self.rows.findIndex((elem) => elem.keyNo === item.keyNo)
        self.rows[targetIndex].newShabanPlateNo = item.newShabanPlateNo
        self.rows[targetIndex].oldShabanPlateNo = item.oldShabanPlateNo
        self.rows[targetIndex].newShadaiNo = item.newShadaiNo
        self.rows[targetIndex].oldShadaiNo = item.oldShadaiNo
        self.rows[targetIndex].sharyoBiko = item.sharyoBiko
        self.rows[targetIndex].sharyoKeishiki = item.sharyoKeishiki
        self.rows[targetIndex].shonendoToroku = item.shonendoToroku
        self.rows[targetIndex].sharyoMaker = item.sharyoMaker
        self.rows[targetIndex].shashu = item.shashu
        self.rows[targetIndex].backeyeKeishiki = item.backeyeKeishiki
        self.rows[targetIndex].etcKeishiki = item.etcKeishiki
        self.rows[targetIndex].refrigeratorMaker = item.refrigeratorMaker
        self.rows[targetIndex].doorNo = item.doorNo
        self.rows[targetIndex].refAnkenNo = item.refAnkenNo
      })
      this.$nextTick().then(() => {
        this.isShowPopupSagyoSharyoListEdit = false
      })
    },

    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    // ----------------------------------------------------------------------
    // 差分デバッグ用
    /*
    _compareClone: function (target) {
      console.log('_compareClone', target, this.cloneData)
      const t1 = JSON.stringify(target.rows)
      const c1 = JSON.stringify(this.cloneData.rows)

      const x1 = t1 !== c1

      return x1
    },
    */
    // ----------------------------------------------------------------------
    dummyfunction () {
      return true
    }
  }
}
</script>
<style scoped>
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 1px !important;
}
td.rightInput {
  text-align: end;
}
th.textBoxWidthLL {
  min-width: 240px !important;
}
th.textBoxWidthL {
  min-width: 200px !important;
}
th.textBoxWidthM {
  min-width: 170px !important;
}
th.textBoxWidthS {
  min-width: 160px !important;
}
th.textBoxWidthSS {
  min-width: 120px !important;
}
th.textBoxWidthSSS {
  min-width: 100px !important;
}
th.textBoxWidthMin {
  min-width: 5px !important;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeader {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5px !important;
  min-width: 30px;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderM {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5px !important;
  min-width: 80px;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderL {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5px !important;
  min-width: 120px !important;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderOption {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5px !important;
  min-width: 20px;
  background-color: lightyellow !important;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderOptionW {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5px !important;
  min-width: 120px;
  background-color: lightyellow !important;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderBuzai {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5x !important;
  min-width: 20px;
  background-color:lightgreen !important;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderBuzaiW {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5x !important;
  min-width: 120px;
  background-color:lightgreen !important;
}
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th.verticalHeaderAppendix {
  text-align: center !important;
  writing-mode: vertical-lr !important;
  height: auto !important;
  padding: 5px 5x !important;
  min-width: 100px;
  background-color:#a9a9a9 !important;
}

.stickyh0 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 4!important;
  background: white;
}
.stickyh1 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-1);
  z-index: 4!important;
  background: white;
  text-align: center !important;
}
.stickyh2 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-2);
  z-index: 4!important;
  background: white;
}
.stickyh3 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-3);
  z-index: 4!important;
  background: white;
}
.stickyh4 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-4);
  z-index: 4!important;
  background: white;
}
.stickyh5 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-5);
  z-index: 4!important;
  background: white;
}
.stickyh6 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-6);
  z-index: 4!important;
  background: white;
}
.stickyh7 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-7);
  z-index: 4!important;
  background: white;
}
.stickyh8 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-8);
  z-index: 4!important;
  background: white;
}
.stickyh9 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-9);
  z-index: 4!important;
  background: white;
}
.sticky0 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 3!important;
  background: white;
}
.sticky1 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-1);
  z-index: 3!important;
  background: white;
  text-align: end !important;
}
.sticky2 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-2);
  z-index: 3!important;
  background: white;
}
.sticky3 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-3);
  z-index: 3!important;
  background: white;
}
.sticky4 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-4);
  z-index: 3!important;
  background: white;
}
.sticky5 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-5);
  z-index: 3!important;
  background: white;
}
.sticky6 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-6);
  z-index: 3!important;
  background: white;
}
.sticky7 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-7);
  z-index: 3!important;
  background: white;
}
.sticky8 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-8);
  z-index: 3!important;
  background: white;
}
.sticky9 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: var(--width-of-9);
  z-index: 3!important;
  background: white;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) > td {
  background: #eeeeee;
}
</style>
